/**
 * Explainer Copy — Plain-language explanations for every stat
 *
 * Voice: 5th grade reading level. No jargon. No encouragement.
 * State facts only. Use the artist's actual numbers where possible.
 *
 * Stat explainers = template strings (instant, no API call).
 * Verdict explainers = always-visible static text.
 */

export const EXPLAINERS = {
  // ── Burn (Money tab — tap BurnProgressCard) ──
  BURN_COVERED: 'Your art income this month has covered all your monthly costs. Everything you earn from here is profit.',
  BURN_TEMPLATE: 'Your monthly burn is what it costs to keep your practice running — rent, supplies, insurance, everything. The bar shows how much of that you have covered with art income so far this month.',

  // ── Pipeline (Money tab — tap PipelineCards) ──
  PIPELINE_BODY: 'Your pipeline tracks the state of every piece you have priced.',
  PIPELINE_AVAILABLE: 'Available means priced but not yet sold.',
  PIPELINE_SOLD: 'Sold means payment received.',
  PIPELINE_REVENUE: 'Revenue is the total amount received from all sales, all time.',

  // ── Verdict inline (always visible, not tappable) ──
  VERDICT_FLOOR: 'The minimum price at which this piece covers your time and materials. Below this, you lose money.',
  VERDICT_EHR: 'What you earn per hour at this price. Gross rate before materials.',
  VERDICT_SUSTAINABILITY: 'How your hourly rate compares to your survival rate. Below 1.0x means you lose money.',
  VERDICT_DELTA_ABOVE: 'Margin above your floor. This covers unexpected costs and builds your practice.',
  VERDICT_DELTA_BELOW: 'Below your floor. At this price, you pay the buyer to take your work.',
  VERDICT_CORRIDOR: 'Breakeven floor is the minimum to cover costs. Market ceiling is the maximum supported by comparable sales at your career stage.',
} as const;

export type ExplainerKey = keyof typeof EXPLAINERS;
